import React from 'react';
import Navbar from '../components/navbar/navbar';
import Footer from '../components/footer/footer';
import './Terms.css';
import SEO from '../components/SEO';

function Terms() {
  return (
    <div className="terms-page-wrapper">
      <SEO 
        title="Terms of Service - Agreement & Guidelines"
        description="Read 9tro Ride's Terms of Service for riders, drivers, couriers, and private chefs. Learn about fares, billing, and cancellations."
        url="https://www.9troride.com/terms"
      />
      <Navbar showSubNavbar={false} />

      <section className="legal-hero">
        <div className="legal-hero-container">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: July 22, 2026</p>
        </div>
      </section>

      <section className="legal-content-section">
        <div className="legal-container">
          <div className="legal-text">
            <h2>1. Agreement to Terms</h2>
            <p>By registering an account with 9tro Ride, you agree to follow our service conditions. This agreement governs passenger rides, food dispatch logistics, and courier services.</p>

            <h2>2. Rider & Passenger Account Rules</h2>
            <p>Riders agree to provide valid phone contact credentials, pay estimated invoice totals upon trip completion, and treat drivers respectfully. Standard cancellation rules apply if a trip is aborted 5 minutes after driver dispatch.</p>

            <h2>3. Driver Subscription Agreements</h2>
            <p>Drivers operate as independent matching contractors. By choosing our Weekly (₦3,500) or Monthly (₦12,000) flat subscriptions, drivers agree to maintain valid licenses, clean vehicles, and complete trip bookings without collecting additional commissions outside the app.</p>

            <h2>4. Culinary & Restaurant T&C</h2>
            <p>Kitchen vendors and private chefs agree to prepare food orders hygienically. Private chefs agree to a flat 5% sales commission deductable from meal payouts. Standard restaurant partners list menus under monthly flat subscriptions.</p>

            <h2>5. Package Dispatch Disclaimers</h2>
            <p>Couriers agree to transport items within package weight constraints (Bicycles: 5kg, Motorcycles: 20kg, Cargo Trucks: 500kg). Customers must not ship hazardous materials, illegal goods, or unregistered contraband. Premium deliveries are insured up to ₦100,000.</p>

            <h2>6. Liability & Service Interruption</h2>
            <p>9tro Ride acts as a real-time dispatch matching coordinator. We are not liable for road traffic delays, internet connection latency spikes, or merchant chef culinary modifications.</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Terms;
